const InternalError: React.FC = () => {
  return <h1>Erro 500</h1>;
};

export default InternalError;
